module.exports = __webpack_public_path__ + "img/hp8.ed159692.png";